import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  clean(e) {
    if (e.detail.success) {
      this.element.reset();
    }
  }
}
